import { paperClasses } from '@mui/material';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: 40,
  height: 36,
  borderRadius: '100% !important',
  backgroundColor: 'transparent',
  transition: theme.transitions.create(['background-color']),

  '&:hover': {
    backgroundColor: `${theme.palette.background.paper} !important`,
  },
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  [`& .MuiBadge-badge`]: {
    color: theme.palette.error.contrastText,
    backgroundColor: `${theme.palette.error.dark} !important`,
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: theme.typography.textXs.fontSize,
    height: 16,
    minWidth: 16,
    padding: theme.spacing(0, 1),
  },
}));

export const StyledPopover = styled(Popover)(({ theme }) => ({
  [`& .${paperClasses.root}`]: {
    backgroundColor: `${theme.palette.background.primaryAlt} !important`,
    width: '100%',
    maxWidth: 400,
    maxHeight: '80vh',
    overflowY: 'auto',
  },
}));
